module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4c6.627 0 12 5.373 12 12s-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4zm7.744 5.672L9.672 23.744A9.959 9.959 0 0016 26c5.523 0 10-4.477 10-10 0-2.4-.846-4.604-2.256-6.328zM16 6C10.477 6 6 10.477 6 16c0 2.4.846 4.604 2.256 6.328L22.328 8.256A9.959 9.959 0 0016 6z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/circular/asda-unavailable.svg
// module id = 652
// module chunks = 0